export default __webpack_public_path__ + "static/media/fNeutral5.c132031b.png";